import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircleInfo} from 'assets/icons/fontawesome/duotone';
import {useState} from 'react';
import {ZeroGradeComment} from 'APIs/letrusAPI/zeroGradeComment/types';
import styles from './ZeroGradeReasons.module.scss';

export interface ZeroGradeReasonsProps {
  reasons: ZeroGradeComment[];
  genreName?: string;
  subtitle?: string;
  isZeroGradeReview?: boolean;
}

function ZeroGradeReasons({
  isZeroGradeReview = false,
  reasons,
  genreName,
  subtitle,
}: ZeroGradeReasonsProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={isZeroGradeReview ? styles.cardZeroGradeReview : styles.card}
    >
      <button
        type="button"
        className={styles.cardTrigger}
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-label="Ver motivos de nota zero"
      >
        <div className={styles.cardTriggerContent}>
          <FontAwesomeIcon icon={faCircleInfo} size="lg" color="#f3af31" />

          <div className={styles.cardTriggerText}>
            <span className={styles.cardTitle}>Motivos de nota zero</span>
            {subtitle && (
              <span className={styles.cardSubtitle}>{subtitle}</span>
            )}
          </div>
        </div>
      </button>

      {isOpen && (
        <div role="region" className={styles.cardContent}>
          <header className={styles.header}>
            <h4>
              Motivos para zerar a redação
              {genreName && ` — ${genreName}`}
            </h4>
          </header>

          <ul className={styles.reasonsList}>
            {reasons?.map((reason) => (
              <li key={reason?.id} className={styles.reasonItem}>
                <span className={styles.bullet} />
                <span>{reason?.title}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default ZeroGradeReasons;
